/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MemberQuoteJournalType {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
}
